const updateCategoryTarget = () => import('@/views/main/target/category-tagetory/cpns/update-category-target/update-category-target.vue')
export default {
  path: '/main/target/updateCategoryTarget',
  name: 'updateCategoryTarget',
  component: updateCategoryTarget,
  children: []
}
